import React, { useState, FC } from 'react';

import Spinner from '../../../../../../components/Spinner';
import Modal from '../../../../components/Modal/Modal';
import {
  ActionableButton,
  ButtonBack,
  ErrorMessage,
  Pin1,
  StepsToFollow,
  WhiteContainer
} from './components';

import { ProcedureWrapper } from '../../../../styled';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

interface CertificateType01ViewProps {
  selectedCertificate: any;
  procedureSelectedInfo: any;
  handleClick: (procedure: any) => void;
  goBack: () => void;
}

const CertificateType01View: FC<CertificateType01ViewProps> = (props) => {
  const { selectedCertificate, procedureSelectedInfo, handleClick, goBack } =
    props;
  const [showModalConfirmation, setShowModalConfirmation]: any =
    useState(false);

  return (
    <ProcedureWrapper
      gap={false}
      data-testid="cmp-certificate-type-01-view"
      className="headingCustom"
    >
      <ButtonBack onClick={goBack} />
      {selectedCertificate && !procedureSelectedInfo && (
        <ProcedureHeader name={selectedCertificate?.name} />
      )}
      {!procedureSelectedInfo && <Spinner />}
      {procedureSelectedInfo && (
        <>
          {/* Se cambió constancias por autogestionables */}
          <ProcedureHeader
            name={procedureSelectedInfo?.name}
            amount={procedureSelectedInfo?.amount}
            duration={procedureSelectedInfo?.duration}
            paddingData={14}
            paddingBottomData={6}
          />
          <WhiteContainer>
            <Pin1 message={procedureSelectedInfo?.pin1} />
          </WhiteContainer>
          <StepsToFollow
            steps={procedureSelectedInfo?.stepsToFollow}
            modelFile={procedureSelectedInfo?.model}
          />
          <ActionableButton
            enabled
            text="Empezar solicitud"
            onClick={() => {
              if (procedureSelectedInfo?.error) {
                setShowModalConfirmation(true);
              } else {
                handleClick(procedureSelectedInfo?.id);
              }
            }}
          />

          <Modal
            show={showModalConfirmation}
            handleClose={() => {
              setShowModalConfirmation(false);
            }}
          >
            <ErrorMessage
              title={procedureSelectedInfo?.error?.title}
              message={procedureSelectedInfo?.error?.description}
              handleClick={() => setShowModalConfirmation(false)}
            />
          </Modal>
        </>
      )}
    </ProcedureWrapper>
  );
};

export default CertificateType01View;
